import React from "react";
import { useQuery } from "@tanstack/react-query";
import parse from "html-react-parser";

import { useThemeChange } from "../../../utils/themeChange";
import { useApi } from "../../../hooks/api/useApi";
import { CMS } from "../../../constants/api-constants";

const { TEMPLATES } = CMS;

const Index = () => {
  const themeChange = useThemeChange();
  const { getById } = useApi();

  const privacyContent = useQuery({
    queryKey: ["privacy"],
    queryFn: () => getById("PRIVACY", TEMPLATES),
  });

  if (privacyContent.isSuccess && privacyContent?.data) {
    const privacy_content = JSON.parse(privacyContent?.data?.data);
    var content = parse(privacy_content?.privacy_policy);
  }
  return (
    <div className={themeChange.add("section")}>
      <section className="container static-page-container">
        <span className="spacer-30" />
        {content ? (
          content
        ) : (
          <div className="error">
            <p>Data Unavailable. Please contact admin.</p>
          </div>
        )}
        {/* <span className="spacer-30" />
        <h2>Privacy Policy</h2>
        <span className="spacer-30" />
        <p>
          ArtSwap LLC ("ArtSwap", "we", "our", or "us") is committed to
          respecting your privacy.
        </p>
        <p>
          Our long-term goal is to provide users with a decentralized platform
          and marketplace that they collectively own – one in which no
          centralized authority collects, stores, processes, transfers, shares
          or uses your personal data. Given this vision of what will be the case
          in the future does not currently exist, this Privacy Policy sets out
          how we collect, store, process, transfer, share and use your personal
          data, and which rights and options you may have in this respect.
        </p>
        <p>
          We collect data about users of our website, application; about
          individuals who attend events organized or hosted by us; about our
          clients or prospective clients (where these are natural persons) or
          their employees, agents and representatives; and about others who
          express an interest in us or with whom we carry on business (and these
          individuals about whom we collect data are referred to as "you" and
          "your" in this Privacy Policy).
        </p>
        <p>
          We set out more details below under How we collect your personal data.
        </p>
        <p>Who is responsible for your personal data?</p>
        <p>
          For the purposes of the European Union General Data Protection
          Regulation 2016/679 and the UK General Data Protection Regulation, the
          data controller for the data you provide or that we collect in
          connection with our website is ArtSwap LLC.
        </p>
        <p>Are you required to provide your personal data?</p>
        <p>
          You do not have to give us any personal data in order to use most of
          our website, and in most instances you will provide us with your
          personal data voluntarily. However, there are circumstances in which
          we may not be able to assist you, or an organization with which you
          are associated, unless you provide us with your personal data. For
          example, as a gallery owner or manager we will require your personal
          data to associate such relationship with your gallery. Your personal
          data may also be required for legally required compliance checks, to
          carry out instructions, for security and other reasons to allow you to
          access one of our events. In these cases, without the relevant
          personal data, we may be unable to assist you or your organization,
          and we would inform you or your organization that this is the case. We
          also may collect some personal data about you automatically – further
          details below.
        </p>

        <p>Which personal data do we collect?</p>
        <p>
          When you use our website or when we interact with you, the personal
          data we collect may include (but is not limited to):
        </p>
        <ul>
          <li>
            Contact information, such as your name, job title, postal address,
            including your home address, where you have provided this to us,
            business address, telephone number, mobile phone number, and email
            address
          </li>
          <li>
            Profile and usage data, including passwords to our websites or
            password-protected platforms or services; your preferences in
            receiving marketing information from us; your communication
            preferences; and information about how you use our websites,
            including the services you viewed.
          </li>
          <li>
            Physical access data, relating to details of your visits to our
            events
          </li>
          <li>
            If you connect to us from a social network, we will collect personal
            information from the social network in accordance with your privacy
            settings on that social network. The connected social network may
            provide us with information such as your name, profile picture,
            network, gender, username, user ID, age or age range, language,
            country, friends list, follower list, and any other information you
            have agreed it can share or that the social network provides to us
          </li>
          <li>
            Special categories of personal data. In connection with the
            registration for and provision of access to an event, we may ask for
            information about your health for the purpose of identifying and
            being considerate of any disabilities or special dietary
            requirements you may have, or for public health reasons, including
            to meet public health requirements or health and safety laws. Your
            provision of this data is based on your consent and our use of it is
            with your consent and/or as required by law.
          </li>
        </ul>
        <p>For our services we may collect</p>
        <ul>
          <li>
            In addition to all or some of the information listed above,
            information collected from publicly available sources or data sites
            for due diligence purposes
          </li>
          <li>
            Identification information from you or from your organization or
            other third parties for compliance with our legal obligations
          </li>
          <li>
            Payment data, such as data necessary for processing payments and
            fraud prevention, and other related billing information
          </li>
          <li>
            Other personal data regarding your preferences, opinions and
            comments where it is relevant to our services
          </li>
        </ul>
        <p>How we collect your personal data</p>
        <p>
          We may collect personal data about you in several circumstances and
          ways, including:
        </p>
        <ul>
          <li>
            When you make an inquiry about our services or otherwise interact
            with us
          </li>
          <li>
            When you attend an event with us or a third party we are working
            with or sign up to receive notifications from us
          </li>
          <li>From social media sites</li>
          <li>Automatically in the ways we describe below.</li>
        </ul>
        <p>Automatic Data Collection</p>
        <p>
          Using tracking software, we automatically collect personal data about
          you when you access and use our websites, blogs, mobile sites,
          applications, sponsored content on social media sites (the “Online
          Information”), and information about the device you use to access the
          Online Information. For example, we may collect:
        </p>
        <ul>
          <li>
            Information about how you view the Online Information (such as the
            pages you view, the links you click)
          </li>
          <li>
            Information about your browser and usage patterns (e.g. your IP
            address, browser type and language)
          </li>
          <li>
            Information about the device you use to access the Online
            Information
          </li>
          <li>Your access via a social media site</li>
        </ul>
        <p>
          We use this information to improve our Online Information and business
          and to help us develop new services. Using email tracking software, we
          collect email traffic headers ("from", "to" and timestamp fields) for
          analyzing patterns of network traffic and managing our relationships.
        </p>
        <p>Third Party websites</p>
        <p>
          Our websites link through to third party websites which may also use
          cookies over which we have no control. We recommend that you check the
          relevant third party's privacy policies for information about any
          cookies which may be used.
        </p>
        <p>Consent for tracking</p>
        <p>
          If you continue to use ArtSwap’s websites we will assume that you
          agree to our tracking. However, if you would prefer to change your
          settings, you can do so at any time - see below “Control”.
        </p>
        <p>Control</p>
        <p>
          If you wish to restrict, block or delete tracking on any of our
          websites, you can generally do this through your browser settings.
          These settings are usually found in the “options” or “preferences”
          menu of your internet browser. If you set your internet browser
          preferences to block tracking software, you may not be able to access
          all or parts of our site.
        </p>
        <p>Use of your personal information</p>

        <p>
          We will use the personal data listed above if and to the extent
          necessary to achieve the following purposes:
        </p>
        <ul>
          <li>To provide services as requested by you or your organization</li>
          <li>
            To manage and administer you or your organization's relationship
            with us, including billing and collection, marketing and support
            services, and taking other steps linked to the performance of our
            business relationship
          </li>
          <li>For insurance purposes</li>
          <li>
            Where applicable, and only as permitted by law with respect to the
            specific category of personal data, to assess your application to
            join us
          </li>
          <li>
            To comply with our legal and regulatory obligations and requests
            anywhere in the world, including reporting to and/or being audited
            by national and international regulatory bodies
          </li>
          <li>
            To comply with court orders and to exercise and/or defend our legal
            rights
          </li>
          <li>
            To assist or enhance your experience at an event; for example,
            details of your dietary requirements
          </li>
          <li>
            To comply with our legal and regulatory obligations such as for
            anti-money laundering, financial and credit checks, audit
            requirements, fraud and crime prevention and detection, and record
            keeping. This may include automated checks of personal data you or
            your organization provide about your identity against relevant
            databases, and contacting you to confirm your identity, or making
            records of our communications with you for compliance purposes
          </li>
          <li>
            To analyze and improve our services and promote our business, such
            as by sending you invites
          </li>
          <li>
            To protect the security of and managing access to our premises, IT
            and communication systems, online platforms, websites and other
            systems, preventing and detecting security threats, fraud or other
            criminal or malicious activities
          </li>
          <li>
            To personalize and foster the quality of our communications and
            interaction with you
          </li>
          <li>
            For any other purposes related and/or ancillary to any of the above,
            or any other purposes for which your personal data was provided to
            us
          </li>
        </ul>
        <p>Legal justification for our use of your personal data</p>
        <p>
          We may process your personal data in connection with any of the
          purposes set out above on one or more of the following legal grounds:
        </p>
        <ul>
          <li>
            Because it is necessary for us to do so to perform your instructions
            or another contract with you or your organization
          </li>
          <li>
            To comply with our legal obligations, as well as to keep records of
            our compliance processes or tax records
          </li>
          <li>
            Because our legitimate interests, or those of a third-party
            recipient of your personal data, make the processing necessary,
            provided that those interests are not overridden by your interests
            or fundamental rights and freedoms
          </li>
          <li>
            Because you have expressly given us your consent to process your
            personal data in that manner
          </li>
        </ul>
        <p>Legal basis in detail</p>
        <p>
          Marketing. We will only provide you with marketing-related information
          after you have, where legally required to do so, opted-in to receive
          those communications. If you have not opted-in to our providing you
          with information promoting our business, we will use your personal
          information for our legitimate interests, provided that those
          interests are not overridden by your interests or fundamental rights
          and freedoms. We will give you the opportunity to opt out at any time.
        </p>
        <p>
          Services. If we are providing you (or your organization) with
          services, our processing will be necessary for the performance of a
          contract between you or your organization and us. Our processing is
          for our legitimate interests in ensuring compliance with our legal
          obligations or to protect our business. In all cases in which our
          legal basis for processing is due to our legitimate interests or those
          of our clients or prospective clients, we will use your personal
          information for our legitimate interests, provided that those
          interests are not overridden by your interests or fundamental rights
          and freedoms.
        </p>
        <p>
          Business partners. If you are engaged by us to provide services, or if
          you wish to be, our processing your personal data will be necessary
          for the performance of a contract, or for our legitimate interests.
        </p>
        <p>
          We will not use your personal data for making any automated decisions
          affecting or creating profiles other than as described above.
        </p>
        <p>Sharing and transferring your personal information</p>
        <p>
          We set out below further details of the ways we may share your
          personal data with:
        </p>
        <ul>
          <li>
            Third parties, including certain service providers we have retained
            in connection with the services we provide, such as lawyers,
            consultants, or other entities
          </li>
          <li>
            A client, if we have collected your personal data in the course of
            providing services to that client, and where permitted by law to
            others for the purpose of providing those services
          </li>
          <li>
            Third parties, on a confidential basis, to help us measure our
            performance and to improve and promote our services
          </li>
          <li>
            Companies providing services for money laundering and terrorist
            financing checks, credit risk reduction, and other fraud and crime
            prevention purposes, and companies providing similar services,
            including financial institutions, credit reference agencies, and
            regulatory bodies with whom such personal data is shared
          </li>
          <li>
            Courts, law enforcement authorities, regulators, government
            officials or other parties where it is reasonably necessary for the
            establishment, exercise or defense of a legal or equitable claim
          </li>
          <li>
            Service providers which we engage to process personal data for any
            of the purposes listed above on our behalf and in accordance with
            our instructions only
          </li>
          <li>
            Prospective sellers or buyers of any business or assets to which we
            might assign or novate any of our rights and obligations; in such
            case we may disclose your personal data to the prospective seller or
            buyer of such business or assets.
          </li>
        </ul>

        <p>
          The personal information we collect may therefore be collected,
          transferred to, and stored in countries outside of the jurisdiction
          you are in, or from the location of ArtSwap, for the purposes
          specified in this Privacy Policy. Any international transfers of your
          personal data will be made pursuant to appropriate safeguards in
          accordance with the applicable laws and regulations. If you wish to
          enquire further about these safeguards used, please contact us using
          the details set out at the end of this Privacy Policy.
        </p>
        <p>
          We do not sell, rent or otherwise make personal information
          commercially available to any third party, except with your prior
          permission.
        </p>
        <p>Protection of your personal information</p>
        <p>
          We adopt appropriate administrative, technical and organizational
          measures designed to protect your personal information from the risk
          of disclosure, destruction, loss or accidental, unlawful and
          unauthorized alteration, access, disclosure and use. We require the
          third-party recipients identified in this notice to use similar
          protective measures when accessing and processing the personal
          information we share.
        </p>
        <p>Your rights</p>
        <p>
          Data protection laws provide certain rights for data subjects. Your
          rights will depend on the laws which apply to you and us, but you may
          have some or all the following rights:
        </p>
        <ul>
          <li>
            To request details of the information we hold about you and how we
            process it
          </li>
          <li>
            To have the personal data we hold rectified or deleted, to restrict
            our processing of that information, to stop unauthorized transfers
            of your personal information to a third party and, in some
            circumstances, to have personal information relating to you
            transferred to another organization
          </li>
        </ul>

        <p>
          If you object to the processing of your personal information, or if
          you have provided your consent to processing and you later choose to
          withdraw it, we will respect that choice in accordance with our legal
          obligations.
        </p>
        <p>
          Your objection (or withdrawal of any previously given consent) could
          mean that we are unable to perform the actions necessary to achieve
          the purposes set out above (see "How we use your personal
          information") or that you may not be able to make use of the services
          and products offered by ArtSwap. Please note that even after you have
          chosen to withdraw your consent, we may be able to continue to process
          your personal information to the extent required or otherwise
          permitted by law, in connection with exercising and defending our
          legal rights or meeting our legal and regulatory obligations. If you
          have provided your consent and wish to withdraw your consent, please
          follow the opt-out links on any marketing message sent to you, or
          contact ArtSwap.
        </p>
        <p>
          Once we have received notification that you have withdrawn your
          consent, we will no longer process your information for the purpose(s)
          to which you originally consented unless there are compelling
          legitimate grounds for further processing which override your
          interests, rights and freedoms, or for the establishment, exercise or
          defense of legal claims. Withdrawal of consent to receive marketing
          communications will not affect the processing of personal data for the
          provision of our services.
        </p>
        <p>
          We must ensure that your personal information is accurate and up to
          date, where relevant. Therefore, please advise us of any changes to
          your information by emailing us.
        </p>
        <p>The internet</p>
        <p>
          This website may, from time to time, contain links to other websites
          which are outside of our control and are not covered by this Privacy
          Policy. We do not accept any responsibility or liability for other
          sites’ privacy policies. If you access other websites using the links
          provided, please check their policies before submitting any personal
          information. Websites operated by ArtSwap currently do not respond to
          “do not track” signals or similar mechanisms.
        </p>
        <p>This Privacy Policy and revisions</p>
        <p>
          We reserve the right to update and change this Privacy Policy from
          time to time to reflect any changes to the way in which we process
          your personal data or changing legal requirements. Please check back
          frequently to this page to see any updates or changes.
        </p>
        <p>Contacting us</p>

        <p>
          Questions, comments and requests regarding this Privacy Policy should
          be addressed to privacy@artswap.com.
        </p>
        <p>Last updated: February 2023</p> */}
      </section>
    </div>
  );
};

export default Index;
